import { createSelector } from 'reselect';
 
const selectChapter = (state: any) => state.chapter;
 
export const selectChapterCurrentItem = createSelector([selectChapter], (chapter) => chapter.current);
 
export const selectChapterListItems = createSelector([selectChapter], (chapter) => chapter.list);
 
 
export const selectChapterItemById = (itemId: any) =>
    createSelector(selectChapterListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectChapterQueryItems = createSelector([selectChapter], (chapter) => chapter.query);

export const selectChapterCreatedItem = createSelector([selectChapter], (chapter) => chapter.create);
 
export const selectChapterUpdatedItem = createSelector([selectChapter], (chapter) => chapter.update);
 
export const selectChapterReadItem = createSelector([selectChapter], (chapter) => chapter.read);
 
export const selectChapterDeletedItem = createSelector([selectChapter], (chapter) => chapter.delete);
 
export const selectChapterSearchedItems = createSelector([selectChapter], (chapter) => chapter.search);
 
export const selectChapterItemsCount = createSelector([selectChapter], (chapter) => chapter.count);
 
export const selectChapterItemsFilter = createSelector([selectChapter], (chapter) => chapter.filter);